import { Model } from 'infra/model'
import { JobScopeChangeStatusAggregations as ScopeChangeRequestStatusAggregationsProto } from '@taxfyle/api-internal/internal/job_scope_change_pb'
import { observable } from 'mobx'
import {
  ScopeChangeRequestStatus,
  toScopeChangeRequestStatus,
} from './ScopeChangeRequest'

export default class ScopeChangeRequestByStatusCount extends Model<
  ScopeChangeRequestStatusAggregationsProto.AsObject,
  ScopeChangeRequestByStatusCount
> {
  @observable status = ScopeChangeRequestStatus.PendingFinalization
  @observable total = 0

  parse(
    json: Partial<ScopeChangeRequestStatusAggregationsProto.AsObject>
  ): Partial<ScopeChangeRequestByStatusCount> {
    return {
      status: toScopeChangeRequestStatus(json.status),
      total: json.total,
    }
  }
}
